import React from 'react';

const StopIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 12C21 16.971 16.971 21 12 21C7.029 21 3 16.971 3 12C3 7.029 7.029 3 12 3C16.971 3 21 7.029 21 12Z"
      fill="#D5DAF3"
    />
    <rect x="9" y="9" width="6" height="6" rx="1" fill="#2D46C1" />
  </svg>
);

export default StopIcon;
